const ConfirmModal = ({
  updateModal,
  updateSwitch,
  fieldName,
  fieldValue,
  handleDelete,
  id,
  msg,
}) => {
  return (
    <>
      <div
        class="modal"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Confirm Delete
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              {msg ? msg : "Are you sure you want to delete?"}
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  if (!updateModal) {
                    // console.log("Delete Called");
                    handleDelete(id);
                  } else {
                    updateSwitch(id, fieldName, fieldValue);
                  }
                }}
              >
                {updateModal ? "Update" : "Delete"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
